"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addFinancingForVehicle = exports.ADD_FINANCING_CAMPAIGN_FOR_VEHICLE = exports.ADD_FINANCING_FOR_VEHICLE = exports.FINANCING = void 0;
exports.FINANCING = 'financing';
exports.ADD_FINANCING_FOR_VEHICLE = `${exports.FINANCING} ADD`;
exports.ADD_FINANCING_CAMPAIGN_FOR_VEHICLE = `${exports.FINANCING} campaign ADD`;
const addFinancingForVehicle = (state = {}) => ({
    type: exports.ADD_FINANCING_FOR_VEHICLE,
    payload: state,
    meta: { feature: exports.FINANCING },
});
exports.addFinancingForVehicle = addFinancingForVehicle;
//# sourceMappingURL=financingAction.js.map